/* eslint-disable import/no-extraneous-dependencies */
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { ButtonText } from '@powdr/constants';

export const MusicianApplicationForm = ({
  captchaSiteKeyBasin,
  processForm,
  isUserVerified,
  setUserVerified,
  handleCaptchaExpiry,
  buttonText,
}) => {
  const captchaRef = useRef();
  return (
    <form
      onSubmit={(e) => processForm(e, '921458eb6be2', null, captchaRef)}
      id="musician-application-form"
    >

      <h3>Band Name *</h3>
      <input
        name="Band Name"
        id="band-name"
        className="form-control"
        type="text"
        required
      />

      <h3>Contact Name *</h3>
      <input
        name="Contact Name"
        id="contact-name"
        className="form-control"
        type="text"
        required
      />

      <h3>Band Address *</h3>
      <input
        name="Band Address"
        id="band-address"
        className="form-control"
        type="text"
        required
      />

      <h3>Cell Phone Number *</h3>
      <input
        name="Phone Number"
        id="phone-number"
        className="form-control"
        type="tel"
        required
      />

      <h3>Email address *</h3>
      <input
        name="Email"
        id="email"
        className="form-control"
        type="email"
        required
      />

      <h3>Artist website</h3>
      <input
        name="Artist Website"
        id="artist-website"
        className="form-control"
        type="text"
      />

      <h3>Social media link *</h3>
      <input
        name="Social Media Link"
        id="social-media-link"
        className="form-control"
        type="text"
        required
      />

      <h3>Music genre *</h3>
      <input
        name="Music Genre"
        id="music-genre"
        className="form-control"
        type="text"
        required
      />

      <h3>Provide links to recent live performances *</h3>
      <input
        name="Live Performance Links"
        id="live-performance-links"
        className="form-control"
        type="textarea"
        rows="9"
        cols="33"
        required
      />

      <ReCAPTCHA
        ref={captchaRef}
        className="recaptcha"
        sitekey={captchaSiteKeyBasin}
        theme="light"
        size="normal"
        onChange={() => setUserVerified(true)}
        onExpired={() => handleCaptchaExpiry()}
      />

      <button type="submit" value="Submit" disabled={!isUserVerified}>{buttonText || ButtonText.SUBMIT}</button>
    </form>
  );
};

MusicianApplicationForm.propTypes = {
  captchaSiteKeyBasin: PropTypes.string.isRequired,
  processForm: PropTypes.func.isRequired,
  setUserVerified: PropTypes.func.isRequired,
  isUserVerified: PropTypes.bool.isRequired,
  handleCaptchaExpiry: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
};
